import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import {getDataIx0} from '../../../services/library';
import Openpdf from '../OpenPdf';

export default function DialogViewOC(props) {
    const [ordenCompra, setOrdenCompra] = useState(null);

    useEffect(() => {
        getDataIx0('/ordencompra/' + props.idOrdenCompra, setOrdenCompra)
    }, [])

    return (
        <React.Fragment>
            <Dialog
                fullScreen
                open={props.open}
                onClose={props.handleClose}
                TransitionComponent={props.TransitionComponent}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={props.handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Orden de Compra
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Container fixed sx={{p:3}}>
                {
                    ordenCompra && (
                        <Openpdf
                            datos={ordenCompra}
                            uuid={ordenCompra?.uuid_ordencompra}
                            readOnly={true}
                        />
                    )
                }
                </Container>
            </Dialog>
        </React.Fragment>
    );
}